import { writable } from 'svelte/store';

import {
    CARD_END_PAGE_TYPE,
    FIRST_SCREEN_IMAGES_CARD_END,
    REMAINING_IMAGES_CARD_END
} from '../constants/imgList';

import ImagePreloader from '@/utils/imagePreloader';

export const loadedImages = writable<Set<string>>(new Set());
export const loadingProgress = writable(0);
export const isFirstScreenLoaded = writable(false);
export const isAllLoaded = writable(false);

interface ImageGroup {
    FIRST_SCREEN_IMAGES: string[];
    REMAINING_IMAGES: string[];
}

const IMAGE_GROUPS: Record<string, ImageGroup> = {
    [CARD_END_PAGE_TYPE]: {
        FIRST_SCREEN_IMAGES: FIRST_SCREEN_IMAGES_CARD_END,
        REMAINING_IMAGES: REMAINING_IMAGES_CARD_END
    }
};

export function startPreload(type: string) {
    const { FIRST_SCREEN_IMAGES, REMAINING_IMAGES } = IMAGE_GROUPS[type] || {};

    if (!FIRST_SCREEN_IMAGES?.length) {
        return;
    }

    const preloader = new ImagePreloader(
        FIRST_SCREEN_IMAGES,
        REMAINING_IMAGES ?? []
    );

    preloader.preload({
        onImageLoad: (src) => {
            loadedImages.update((images) => {
                images.add(src);

                return images;
            });
        },
        onProgress: (progress) => {
            loadingProgress.set(progress);
        },
        onFirstScreenComplete: () => {
            isFirstScreenLoaded.set(true);
        },
        onAllComplete: () => {
            isAllLoaded.set(true);
        },
        onError: (error) => {
            console.error('[MXCreditCardBALL] image preload error:', error);
            loadingProgress.update((progress) => Math.min(progress + 1, 100));
        },
        shouldPreload: (src) => {
            let shouldLoad = true;

            loadedImages.update((images) => {
                if (images.has(src)) {
                    shouldLoad = false;
                }

                return images;
            });

            return shouldLoad;
        }
    });
}
